/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { VariantGetByIdV2 } from '../models/variant-get-by-id-v-2';
import { variantsControllerCreateOptimalVariant } from '../fn/variants-controller/variants-controller-create-optimal-variant';
import { VariantsControllerCreateOptimalVariant$Params } from '../fn/variants-controller/variants-controller-create-optimal-variant';
import { variantsControllerCreateVariant } from '../fn/variants-controller/variants-controller-create-variant';
import { VariantsControllerCreateVariant$Params } from '../fn/variants-controller/variants-controller-create-variant';
import { variantsControllerDeleteVariant } from '../fn/variants-controller/variants-controller-delete-variant';
import { VariantsControllerDeleteVariant$Params } from '../fn/variants-controller/variants-controller-delete-variant';
import { variantsControllerGetVariant } from '../fn/variants-controller/variants-controller-get-variant';
import { VariantsControllerGetVariant$Params } from '../fn/variants-controller/variants-controller-get-variant';
import { variantsControllerPatchVariant } from '../fn/variants-controller/variants-controller-patch-variant';
import { VariantsControllerPatchVariant$Params } from '../fn/variants-controller/variants-controller-patch-variant';


/**
 * API resource for variants manipulation.
 */
@Injectable({ providedIn: 'root' })
export class VariantsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `variantsControllerCreateVariant()` */
  static readonly VariantsControllerCreateVariantPath = '/planning-projects/v2-preview/variants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `variantsControllerCreateVariant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerCreateVariant$Response(params?: VariantsControllerCreateVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<VariantGetByIdV2>> {
    return variantsControllerCreateVariant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `variantsControllerCreateVariant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerCreateVariant(params?: VariantsControllerCreateVariant$Params, context?: HttpContext): Observable<VariantGetByIdV2> {
    return this.variantsControllerCreateVariant$Response(params, context).pipe(
      map((r: StrictHttpResponse<VariantGetByIdV2>): VariantGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `variantsControllerGetVariant()` */
  static readonly VariantsControllerGetVariantPath = '/planning-projects/v2-preview/variants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `variantsControllerGetVariant()` instead.
   *
   * This method doesn't expect any request body.
   */
  variantsControllerGetVariant$Response(params: VariantsControllerGetVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<VariantGetByIdV2>> {
    return variantsControllerGetVariant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `variantsControllerGetVariant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  variantsControllerGetVariant(params: VariantsControllerGetVariant$Params, context?: HttpContext): Observable<VariantGetByIdV2> {
    return this.variantsControllerGetVariant$Response(params, context).pipe(
      map((r: StrictHttpResponse<VariantGetByIdV2>): VariantGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `variantsControllerDeleteVariant()` */
  static readonly VariantsControllerDeleteVariantPath = '/planning-projects/v2-preview/variants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `variantsControllerDeleteVariant()` instead.
   *
   * This method doesn't expect any request body.
   */
  variantsControllerDeleteVariant$Response(params: VariantsControllerDeleteVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return variantsControllerDeleteVariant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `variantsControllerDeleteVariant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  variantsControllerDeleteVariant(params: VariantsControllerDeleteVariant$Params, context?: HttpContext): Observable<void> {
    return this.variantsControllerDeleteVariant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `variantsControllerPatchVariant()` */
  static readonly VariantsControllerPatchVariantPath = '/planning-projects/v2-preview/variants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `variantsControllerPatchVariant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerPatchVariant$Response(params: VariantsControllerPatchVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<VariantGetByIdV2>> {
    return variantsControllerPatchVariant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `variantsControllerPatchVariant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerPatchVariant(params: VariantsControllerPatchVariant$Params, context?: HttpContext): Observable<VariantGetByIdV2> {
    return this.variantsControllerPatchVariant$Response(params, context).pipe(
      map((r: StrictHttpResponse<VariantGetByIdV2>): VariantGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `variantsControllerCreateOptimalVariant()` */
  static readonly VariantsControllerCreateOptimalVariantPath = '/planning-projects/v2-preview/variants/optimal';

  /**
   * Creates an optimal variant for the project based on project data and optimization results.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `variantsControllerCreateOptimalVariant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerCreateOptimalVariant$Response(params: VariantsControllerCreateOptimalVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<VariantGetByIdV2>> {
    return variantsControllerCreateOptimalVariant(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an optimal variant for the project based on project data and optimization results.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `variantsControllerCreateOptimalVariant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  variantsControllerCreateOptimalVariant(params: VariantsControllerCreateOptimalVariant$Params, context?: HttpContext): Observable<VariantGetByIdV2> {
    return this.variantsControllerCreateOptimalVariant$Response(params, context).pipe(
      map((r: StrictHttpResponse<VariantGetByIdV2>): VariantGetByIdV2 => r.body)
    );
  }

}
